import { createRestClient, ApiError } from "@marekl/adminer/api";
import { runtimeConfig } from "./config";
import { handleSessionExpiry } from "../auth/sessionExpiry";

/**
 * The app's single HTTP client. A `RestClient` is also an `ApiClient`, so this
 * one object is:
 * - the transport for auth — passed to `createRestAuthAdapter({ api: apiClient })`
 *   in `main.tsx`, and
 * - the REST data client — `apiGet`/`apiPost`/… below (verbs + CSRF + Dayjs).
 *
 * CSRF: the server issues the `adminer_csrf` cookie; the client echoes it as
 * `X-CSRF-Token` on every mutating request (the lib default cookie name).
 *
 * Its `onUnauthorized` fires for **every** 401 (auth and data, queries and
 * mutations) from one place — no per-surface wiring needed.
 */
export const apiClient = createRestClient({
  baseUrl: runtimeConfig.apiBaseURL,
  onUnauthorized: handleSessionExpiry,
});

export { ApiError };
export const apiGet = apiClient.get;
export const apiPost = apiClient.post;
export const apiPut = apiClient.put;
export const apiPatch = apiClient.patch;
export const apiDelete = apiClient.delete;
